import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useAuth } from '@/contexts/AuthContext';
import { Building2 } from 'lucide-react';

export function StudioSwitcher() {
  const { studios, publisher, setActiveStudio } = useAuth();

  if (studios.length <= 1) {
    if (!publisher) return null;
    return (
      <div className="px-2 py-1">
        <p className="text-xs text-sidebar-foreground/50 kinora-eyebrow !text-[0.55rem] !tracking-[0.18em]">
          Studio
        </p>
        <p className="truncate text-sm font-medium text-sidebar-foreground">
          {publisher.company_name || 'My studio'}
        </p>
      </div>
    );
  }

  return (
    <div className="px-2 py-1 space-y-1">
      <p className="text-xs text-sidebar-foreground/50 kinora-eyebrow !text-[0.55rem] !tracking-[0.18em] flex items-center gap-1">
        <Building2 className="h-3 w-3" /> Active studio
      </p>
      <Select
        value={publisher?.id ?? ''}
        onValueChange={(id) => void setActiveStudio(id)}
      >
        <SelectTrigger className="h-9 w-full bg-sidebar-accent/30">
          <SelectValue placeholder="Select studio" />
        </SelectTrigger>
        <SelectContent>
          {studios.map(({ publisher: studio, membership }) => (
            <SelectItem key={studio.id} value={studio.id}>
              {studio.company_name || 'Unnamed studio'}
              {membership ? ` (${membership.role})` : ' (owner)'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
